export const value = (event) => event.target.value;
